export const API_URL =
  process.env.REACT_APP_HOST_ENV === "production"
    ? "https://multimarket-api.fly.dev"
    : "http://localhost:8080";
export const TIMEOUT = 30000;
